export { default } from './SettingsCert.jsx';
